import { Box } from "@mui/joy";
import DarkTypography from "../../common/DarkTypography";
import { mailEditorShellSx, mailEditorVariablesZoneSx } from "../../../styles/globalStyles";
import { mailEditorBelowToolbarSx } from "./mailEditorShared";
import { useMailTemplatesPageState } from "./hooks/useMailTemplatesPageState";
import MailEditorToolbar from "./display/MailEditorToolbar";
import MailEditorEnvelopeStrip from "./display/MailEditorEnvelopeStrip";
import MailEditorBodyWorkspace from "./display/MailEditorBodyWorkspace";
import MailEditorPlaceholderChips from "./display/MailEditorPlaceholderChips";

const variablesSectionTitleSx = {
  lineHeight: 1.2,
  mb: 0.35,
  minHeight: "1.1em",
} as const;

export default function MailTemplatesPage() {
  const {
    typeFilter,
    onTypeFilterChange,
    templates,
    template,
    setTemplate,
    blocks,
    loading,
    saving,
    onSelectTemplateId,
    placeholderCatalog,
    envelopeSubjectPlaceholderChips,
    envelopeRecipientPlaceholderChips,
    palettePlaceholderChips,
    interactivePlaceholderKeys,
    placeholderChipAllowDrag,
    booleanConditionPlaceholders,
    previewFullHtml,
    previewLoading,
    blockEditorRef,
    handleBlocksChange,
    onNewTemplate,
    onSave,
    onDuplicate,
    onDelete,
    insertPlaceholder,
    setPlaceholderTarget,
    registerSubjectInsert,
    canEdit,
  } = useMailTemplatesPageState();

  return (
    <Box sx={mailEditorShellSx}>
      <MailEditorToolbar
        typeFilter={typeFilter}
        onTypeFilterChange={onTypeFilterChange}
        templates={templates}
        template={template}
        loading={loading}
        saving={saving}
        canEdit={canEdit}
        onSelectTemplateId={onSelectTemplateId}
        onNewTemplate={onNewTemplate}
        onSave={onSave}
        onDuplicate={onDuplicate}
        onDelete={onDelete}
        onTemplateChange={setTemplate}
      />

      <Box sx={mailEditorBelowToolbarSx}>
        {canEdit && template && palettePlaceholderChips.length > 0 ? (
          <Box sx={mailEditorVariablesZoneSx}>
            <DarkTypography level="body-xs" colorVariant="muted" sx={variablesSectionTitleSx}>
              Variables
            </DarkTypography>
            <MailEditorPlaceholderChips
              placeholdersForInsert={palettePlaceholderChips}
              labelLookupCatalog={placeholderCatalog}
              canEdit={canEdit}
              onInsertPlaceholder={insertPlaceholder}
              interactiveKeys={interactivePlaceholderKeys}
              allowDrag={placeholderChipAllowDrag}
            />
          </Box>
        ) : null}
        <MailEditorEnvelopeStrip
          template={template}
          onTemplateChange={setTemplate}
          canEdit={canEdit}
          placeholderCatalog={placeholderCatalog}
          subjectPlaceholderChips={envelopeSubjectPlaceholderChips}
          recipientPlaceholderChips={envelopeRecipientPlaceholderChips}
          onPlaceholderTargetChange={setPlaceholderTarget}
          registerSubjectInsert={registerSubjectInsert}
        />
        <MailEditorBodyWorkspace
          template={template}
          blocks={blocks}
          onBlocksChange={handleBlocksChange}
          canEdit={canEdit}
          blockEditorRef={blockEditorRef}
          previewFullHtml={previewFullHtml}
          previewLoading={previewLoading}
          booleanConditionPlaceholders={booleanConditionPlaceholders}
          placeholderCatalog={placeholderCatalog}
          onPlaceholderTargetChange={setPlaceholderTarget}
        />
      </Box>
    </Box>
  );
}
